import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Form, FormGroup, Div, Forms, H3, LabelField } from './SocialSecurity.styles';
import apis from '../../api';
import { saveAs } from 'file-saver';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import useParamsSocial from '../../helpers/useParamsSocial'
import dateFormat from '../../services/DateFormat.service';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { addLocale } from 'primereact/api'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode } from 'primereact/api';
import { ProgressBar } from 'primereact/progressbar';
import { Chart } from 'primereact/chart';
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import './SocialSecurity.css'
import { useHistory } from "react-router-dom";
import { excelReport } from '../../services/excelReport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : SocialSecurity
Description : Generación de reporte.
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina Creación 
================================================================================ */

export default function SocialSecurity(props) {

    const toast = useRef(null);
    const [isOpen, setIsOpen] = React.useState(false);
    const [isOpenAcum, setIsOpenAcum] = React.useState(false);
    const [calendar, setCalendar] = useState("");
    const [listaOptionsCalendar, setOptionsCalendar] = useState([{ "value": "", "label": "" }]);
    const elementWidth = { width: "20rem", justifySelf: "center" }
    const headers = { authorization: localStorage.getItem('token') }
    const client = localStorage.getItem('client');
    const [isOpenRS, setIsOpenRS] = React.useState(false);
    const [params] = useParamsSocial();
    const [socialSecurity, setSocialSecurity] = useState([]);
    const [rows, setRows] = useState([]);
    const [first2, setFirst2] = useState(0);
    const [rows2, setRows2] = useState(10);
    const [selectedRows, setSelectedRows] = useState(null);
    const [filters1, setFilters1] = useState(null);
    const [consultado, setConsultado] = useState(false)
    const [loadingProcesar, setLoadingProcesar] = useState(false);
    const [loadingAcomular, setLoadingAcomular] = useState(false);
    const [loadingDeshacer, setLoadingDeshacer] = useState(false);
    const [loadingArchivo, setLoadingArchivo] = useState(false);
    const [loadingGenerar, setLoadingGenerar] = useState(false);
    const [loadingConsultar, setLoadingConsultar] = useState(false);
    const [loadPage, setLoadPage] = useState(false)

    const [labelsGrafica, setLabelsGrafica] = useState([])
    const [datasetGrafica, setDatasetGrafica] = useState([])
    const [nombreGrafica, setNombreGrafica] = useState("")

    const [errorRows, setErrorRows] = useState([])
    const [isOpenErrors, setIsOpenErrors] = useState(false)

    let history = useHistory();

    useEffect(() => {
        listCalendar();
    }, []);

    useEffect(() => {
        const getLists = async () => {
            let plantilla = []
            params.forEach((p, index) => {
                if (p.TAG === 'pinEntity' || p.TAG === 'pinClient') {
                    plantilla.push({ NAME: p.OPTIONS[0].NAME, CODE: p.OPTIONS[0].CODE, LABEL: p.TAG, SHEET: p.SHEET_POSITION, REQUIRED: p.REQUIRED })
                }
                else {
                    plantilla.push({ NAME: "", CODE: "", LABEL: p.TAG, SHEET: p.SHEET_POSITION })
                }
            })
            console.log(plantilla)
            setSocialSecurity(plantilla)
        }
        getLists()
    }, [params]);

    useEffect(() => {
        infoGrafica()
    }, []);

    addLocale('es', {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Claro'
    });

    const barGraph = {
        labels: labelsGrafica,
        datasets: datasetGrafica
    };

    const options = (nombre, tipo, grafica) => {
        const opciones = {
            plugins: {
                tooltip: {
                    position: 'average',
                    borderWidth: '100',
                    callbacks: {
                        labelTextColor: function (context) {
                            return 'white';
                        },
                        label: function (dataset) {
                            let label = dataset.label || '';
                            let data = dataset.parsed || '';
                            if (grafica !== "dona") {
                                data = dataset.parsed.y;
                            }

                            if (label) {
                                label += ': ';
                            }

                            if (tipo === 'currency') {
                                if (data !== null) {
                                    label += new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(data);
                                }
                            }
                            else {
                                label += data;
                            }
                            return label;
                        }
                    }
                },
                title: {
                    display: true,
                    text: nombre,
                    color: 'black',
                    font: {
                        size: '20',
                    },
                    padding: {
                        top: 0
                    }
                },
                legend: {
                    align: grafica === "dona" ? 'start' : 'center',
                }
            }
        }
        return opciones
    }

    function handleSubmit(event) {
        event.preventDefault();
    }

    const showModalRS = () => {
        setIsOpenRS(true);
    };


    const showModal = () => {
        setIsOpen(true);
        setCalendar("")
    }

    const hideModal = () => {
        setIsOpen(false);
        setConsultado(false)
    }

    const hideModalRS = () => {
        setIsOpenRS(false);
    };

    const showModalAcum = () => {
        setIsOpenAcum(true);
    };

    const hideModalAcum = () => {
        setIsOpenAcum(false);
    };

    async function listCalendar() {
        await apis.getValueListCalendar('SS', headers).then(res => {
            let data = res.data.CALENDAR
            let tipoCalendar = data;
            let contenidoTipoCalendar = [];
            tipoCalendar.forEach(res =>
                contenidoTipoCalendar.push({ "value": '' + res.ID_CALENDAR + '', "label": '' + res.DETAIL + '' })
            )
            setOptionsCalendar(contenidoTipoCalendar)
        }).catch(err => {
            setOptionsCalendar([])
        })
    }

    async function createFile() {
        setLoadingArchivo(true)

        apis.getValueFiles_raw(localStorage.getItem('entity'), client, calendar.value, headers).then(res => {
            let file_name = res.data.NAME
            let data = res.data.DETAIL
            let text = data;
            let contenido = "";
            text.forEach(res => {
                contenido += res.LINE + '\r\n';
            })
            const blob = new Blob([contenido], { type: 'text/plain;charset=utf-8' });
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Se generó el archivo plano', life: 4000 });
            saveAs(blob, file_name);
            setLoadingArchivo(false)
        }).catch(err => {
            setLoadingArchivo(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
        })
    }

    async function process(action) {
        const p = {
            ID_CALENDAR: calendar.value,
            CLIENT: localStorage.getItem('client'),
            ENTITY: localStorage.getItem('entity'),
            ACTION: action
        }

        if (action == "PRO") {
            setLoadingProcesar(true)
        } if (action == "CLO") {
            setLoadingAcomular(true)
        } if (action == "REV") {
            setLoadingDeshacer(true)
        }

        await apis.executeProcess(p, headers).then(res => {
            switch (action) {
                case "PRO":
                    setLoadingProcesar(false)
                    setTabla()
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'PROCESADO CON EXITO', life: 4000 });
                    infoGrafica()
                    return listCalendar()
                case "CLO":
                    setLoadingAcomular(false)
                    hideModalAcum()
                    setTabla()
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'ACUMULADO CON EXITO', life: 4000 });
                    infoGrafica()
                    return listCalendar()
                case "REV":
                    setLoadingDeshacer(false)
                    setTabla()
                    toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'REVERSADO CON EXITO', life: 4000 });
                    infoGrafica()
                    return listCalendar()
            }
        }).catch(err => {
            setLoadingDeshacer(false)
            setLoadingAcomular(false)
            setLoadingProcesar(false)
            toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
        })
    }

    async function postSocialReport() {
        setLoadingGenerar(true)
        let finalReport = []
        const client = localStorage.getItem('client')
        const entity = localStorage.getItem('entity')
        const option = "1"
        let report = {
            CLIENT: client,
            ENTITY: entity,
            OPTION: option,
            REPORTS: []
        }
        let max = 0
        socialSecurity.forEach(n => {
            let size = n.SHEET.length
            if (size > max) {
                max = size
            }
        })
        for (let i = 0; i < max; i++) {
            report.REPORTS.push({ PARAMETERS: [] })
        }

        socialSecurity.forEach(n => {
            n.SHEET.forEach(e => {
                report.REPORTS[e].PARAMETERS.push({ LABEL: n.LABEL, VALUE: n.CODE })
            })
        })
        try {
            await apis.postReportSocialSecurity(report, headers).then(res => {
                finalReport = res.data
                excelReport(finalReport, 'reporteSS')
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte de Seguridad Social generado existosamente" });
                setLoadingGenerar(false)
            })
        }
        catch (err) {
            setLoadingGenerar(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    async function setTabla() {
        setLoadingConsultar(true)
        const _calendario = calendar.value
        try {
            await apis.getExecutedProcess(localStorage.getItem('entity'), _calendario, localStorage.getItem('client'), "NULL", headers).then(res => {
                if (res.data["PROCESS"].length > 0) {
                    let data = res.data["PROCESS"]
                    setRows(data)
                    setConsultado(true)
                    setLoadingConsultar(false)
                }
                else {
                    setLoadingConsultar(false)
                    setRows([])
                }
            })
        }
        catch (err) {
            setLoadingConsultar(false)
            toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
        }
    }

    const infoGrafica = async () => {
        try {
            await apis.getGraphSS(localStorage.getItem('entity'), localStorage.getItem('client'), headers).then(res => {
                let grafica = res.data
                let dataset = grafica.datasets
                let labels = grafica.label
                let name = grafica.name

                setDatasetGrafica(dataset)
                setLabelsGrafica(labels)
                setNombreGrafica(name)
                setLoadPage(true)
            })
        }
        catch (err) {
            console.log(err)
            setLoadPage(true)
        }
    }

    const matchModes = [
        { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
        { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
        { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
        { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
        { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
        { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
    ];



    const percentageBodyTemplate = (rowData) => {
        return <ProgressBar value={rowData.PERCENTAGE}></ProgressBar>;
    }

    const onCustomPage2 = (event) => {
        setFirst2(event.first);
        setRows2(event.rows);
    }

    const headerLN = (
        <div>
            <h3>Seleccionar calendario para liquidación de Seguridad social</h3>
        </div>
    )

    const tableHeader = (
        <div className="table-header">
            <Button icon="pi pi-refresh" tooltip="Refrescar tabla" tooltipOptions={{ position: 'top' }} className="p-button-succcess mr-2 p-button-sm" onClick={() => setTabla()} />
        </div>
    );

    const rowClassName = (rowData) => {
        return { 'error-row': (rowData["STATUS"] === "ERROR") };
    }

    const actionBodyTemplateErrors = (rowData) => {
        console.log(rowData.ERRORS)
        return (
            <div>
                {rowData.ERRORS && <Button icon="pi pi-search" className="p-button-info mr-2 p-button-sm text-xs" tooltip="Visualizar errores" tooltipOptions={{ position: 'top' }} onClick={() => { setErrorRows(rowData.ERRORS); setIsOpenErrors(true) }} />}
            </div>
        )
    }

    const footerLN = (
        <>
            <div>
                <Button onClick={() => process("PRO")} disabled={calendar.value == undefined} loading={loadingProcesar} label='Procesar'></Button>
                <Button onClick={() => process("REV")} disabled={calendar.value == undefined} loading={loadingDeshacer} label='Deshacer'></Button>
                <Button block type="submit" onClick={createFile} disabled={calendar.value == undefined} loading={loadingArchivo} label='Archivo plano'></Button>
                <Button onClick={showModalAcum} disabled={calendar.value == undefined} label='Acumular'></Button>
            </div>
            {consultado === true && calendar.value != undefined ?
                <div className="datatable-style-demo">
                    <DataTable className="text-xs" header={tableHeader} value={rows} first={first2} rows={rows2} onPage={onCustomPage2}
                        responsiveLayout="scroll" selection={selectedRows} onSelectionChange={(e) => setSelectedRows(e.value)} dataKey="ID"
                        size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['ID', 'TRHEAD', 'JOB', 'RECORD', 'START', 'END', 'PROCESSED', 'ERROR', 'PERCENTAGE', 'ACTION', 'STATUS']}
                        rowClassName={rowClassName}
                    >
                        <Column showFilterOperator={false} filterMatchModeOptions={matchModes} body={actionBodyTemplateErrors}></Column>
                        <Column field="ID" header="ID" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por ID" sortable></Column>
                        <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
                        <Column field="PERCENTAGE" header="Porcentaje" body={percentageBodyTemplate} showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Porcentaje" sortable></Column>
                        <Column field="ACTION" header="Proceso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Proceso" sortable></Column>
                        <Column field="TRHEAD" header="Hilo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Hilo" sortable></Column>
                        <Column field="RECORD" header="Registro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Registro" sortable></Column>
                        <Column field="START" header="Fecha inicio" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha inicio" sortable></Column>
                        <Column field="END" header="Fecha fin" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Fecha fin" sortable></Column>
                        <Column field="PROCESSED" header="Procesados" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Procesados" sortable></Column>
                        <Column field="ERROR" header="Error" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Error" sortable></Column>
                    </DataTable>
                </div>
                : null}
        </>
    );

    function handleChange(e, d, index) {
        //console.log(e.value)
        setSocialSecurity(n => {
            let newNomina = [...n]
            // console.log(index)
            // console.log(n)
            newNomina[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })

        //console.log(nomina[index]["NAME"])
    }

    async function handleChangeDate(e, d, index) {
        console.log(e.value)
        let date = dateFormat(e.value)
        setSocialSecurity(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
        //console.log(nomina)
    }

    async function handleChangeText(e, d, index) {
        console.log(e.value)
        setSocialSecurity(n => {
            let newNomina = [...n]
            newNomina[index] = { CODE: e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
            return newNomina
        })
        //console.log(nomina)
    }

    const headerRS = (
        <div>
            <h3>Parámetros reporte de Seguridad Social</h3>
        </div>
    )

    const footerRS = (
        <div>
            <Button onClick={() => postSocialReport()} loading={loadingGenerar} label='Generar'></Button>
        </div>
    );

    const headerAcum = (
        <div>
            <h3>¿Desea realizar la acumulación del proceso?</h3>
        </div>
    )

    const footerAcum = (
        <div>
            <Button label="Si" loading={loadingAcomular} onClick={() => { setLoadingAcomular(true); process("CLO") }} />
            <Button label="No" onClick={hideModalAcum} />
        </div>
    );

    return (
        <div className="surface-100	 px-4 py-5 md:px-6 lg:px-8">
            <Toast ref={toast} />
            <Dialog header={headerLN} footer={footerLN} visible={isOpen} maximizable
                position="top" style={{ width: "40rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
                <div className='block'>
                    <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                </div>

                <LabelField htmlFor="label">Calendario liquidación de Seguridad social *</LabelField>
                <div className="p-inputgroup">
                    <Dropdown style={elementWidth} value={calendar.value}
                        filter showClear filterBy="label"
                        options={listaOptionsCalendar} placeholder={"Seleccione el calendario"}
                        onChange={(e) => {
                            let label = e.originalEvent.nativeEvent.target.textContent;
                            setCalendar({ "value": e.value, "label": label })
                        }}
                    />
                    <Button icon="pi pi-search" loading={loadingConsultar} disabled={calendar.value == false || calendar.value == undefined} className="mr-2 p-button-sm text-xs" tooltip="Consultar procesos anteriores" tooltipOptions={{ position: 'top' }} onClick={() => setTabla()} />
                </div>
            </Dialog>
            <Dialog header={headerAcum} footer={footerAcum} visible={isOpenAcum} position="top"
                style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalAcum} />
            <Dialog header={headerRS} footer={footerRS} visible={isOpenRS} bo
                position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalRS}>
                <span style={{ fontSize: "0.8rem" }}>Campos obligatorios (*)</span>
                {params.map((d, index) => {
                    // console.log(d)
                    if (d.TAG !== "pinClient" && d.TAG !== "pinEntity" && socialSecurity.length > 0 && typeof socialSecurity[index] !== "undefined") {
                        let label = d.LABEL
                        if (d.REQUIRED == '1') {
                            label = label + '*'
                        }
                        switch (d.TYPE) {
                            case "LIST":
                                let options = [{ CODE: "NULL", NAME: "NO APLICA" }, ...d.OPTIONS]
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Dropdown
                                        key={index}
                                        style={elementWidth}
                                        value={socialSecurity[index]["NAME"]}
                                        options={options}
                                        filter filterBy="NAME"
                                        optionLabel="NAME"
                                        //optionTemplate={optionTemplate}
                                        placeholder={socialSecurity[index]["NAME"] ? socialSecurity[index]["NAME"] : "Seleccione"}
                                        onChange={(e) => handleChange(e, d, index)}
                                    />
                                </>
                                );
                            case "DATE":
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <Calendar key={d} style={elementWidth} id="navigators" value={socialSecurity[index].CODE}
                                        onChange={(e) => handleChangeDate(e, d, index)}
                                        locale="es" dateFormat="dd-mm-yy" showIcon placeholder={socialSecurity[index].CODE}
                                        yearRange="2010:2030" /></>
                                );
                            default:
                                return (<>
                                    <LabelField htmlFor="label">{label}</LabelField>
                                    <InputText
                                        key={d}
                                        style={elementWidth}
                                        id="label2"
                                        type="text"
                                        value={socialSecurity[index]}
                                        onChange={(e) => handleChangeText(e, d, index)}
                                    /></>
                                )
                        }
                    }
                })}
            </Dialog>

            <Dialog header={"Errores"} visible={isOpenErrors}
                position="top" style={{ width: "70vw" }} draggable={false} resizable={false} modal onHide={() => setIsOpenErrors(false)}>
                <div className="datatable-style-demo flex flex-column justify-content-center align-items-center">

                    <DataTable className="text-xs" value={errorRows} dataKey="CONTRACT_ID">
                        <Column field="CONTRACT_ID" header="Contrato" showFilterOperator={false}></Column>
                        <Column field="MESSAGE" header="Mensaje" showFilterOperator={false}></Column>
                    </DataTable>
                </div>
            </Dialog>

            <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-2">
                <span className="text-900">Liquidación</span>
                <Video header="Instructivo proceso seguridad social" url={localStorage.getItem('SOCIALSECURITY_VIDEO')} />
            </div>

            <Form onSubmit={handleSubmit}>
                <div className='cards'>
                    <Card className='shadow-5' style={{ width: '60vw' }}>
                        <SkeletonTable load={loadPage} height='60vh'>
                            <Chart type="bar" className='card1' data={barGraph} options={options(nombreGrafica, 'currency', 'bar')} />
                        </SkeletonTable>
                    </Card>
                    &nbsp;
                    <Card className='card2 shadow-5'>
                        <Forms className=''>
                            <H3 className='content2'>Seguridad Social</H3>
                            <Button block type="submit" onClick={showModal} style={{ marginBottom: '2rem' }} label='Liquidar Seguridad Social' />
                            <H3>Consulta</H3>
                            <div className='flex flex-column gap-3'>
                                <Button block type="submit" onClick={showModalRS} label='Reporte Seguridad Social' />
                                <Button block type="submit" onClick={() => history.push("/PILASheets")} label='Planillas PILA' />
                            </div>
                        </Forms>
                    </Card>
                </div>
            </Form>

        </div>
    );
}